export const SmsTypes = {
  LOAN_CONSENT_CUSTOMER_AGENT: "loanConsentCustomerAgent",
  ON_BOARDING_AGENT: "onBoardingAgent",
  LOGIN: "login",
  KYC: "kyc",
  MOBILE_VERIFICATION : "mobileVerification"
};
